module.exports = __webpack_public_path__ + "img/f5.8064e220.png";